import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navigation = [{
    name: 'How It Works',
    href: '/how-it-works'
  }, {
    name: 'Who We Serve',
    href: '/who-we-serve'
  }, {
    name: 'Case Studies',
    href: '/case-studies'
  }, {
    name: 'About',
    href: '/about'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`} data-id="element-54">
      <nav className="container-custom" data-id="element-55">
        <div className="flex items-center justify-between h-20" data-id="element-56">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 group flex-shrink-0" data-id="element-57">
            {/* New Logo */}
            <div className="flex items-center" data-id="element-58">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6uXF7HWdEdxKw6n2nmi2JZ/HIRE_%281%29.png" alt="HIRE" className="h-12 w-auto transition-transform group-hover:scale-105" data-id="element-59" />
            </div>

            {/* Divider */}
            <div className="w-px h-12 bg-gray-300" data-id="element-60"></div>

            {/* Acronym Breakdown - Shows on all screen sizes */}
            <div className="text-left flex flex-col justify-center h-12" data-id="element-61">
              <div className="text-[10px] font-bold text-amber uppercase tracking-wider leading-tight" data-id="element-62">
                High Impact
              </div>
              <div className="text-[10px] font-bold text-navy uppercase tracking-wider leading-tight" data-id="element-63">
                Recruiting Engine
              </div>
            </div>
          </a>

          {/* Desktop Navigation - Hide earlier to prevent wrapping */}
          <div className="hidden xl:flex items-center space-x-8" data-id="element-64">
            {navigation.map(item => <a key={item.name} href={item.href} className="text-gray-700 hover:text-navy font-medium transition-colors whitespace-nowrap" data-id="element-65">
                {item.name}
              </a>)}
          </div>

          {/* CTA Button - Hide earlier to prevent wrapping */}
          <div className="hidden xl:block flex-shrink-0" data-id="element-66">
            <Button href="/book-call" showArrow data-id="element-67">
              Schedule a Strategy Call
            </Button>
          </div>

          {/* Mobile Menu Button - Show earlier */}
          <button className="xl:hidden p-2 text-gray-700" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-68">
            {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-69" /> : <MenuIcon className="h-6 w-6" data-id="element-70" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="xl:hidden py-4 border-t" data-id="element-71">
            <div className="flex flex-col space-y-4" data-id="element-72">
              {navigation.map(item => <a key={item.name} href={item.href} className="text-gray-700 hover:text-navy font-medium py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-73">
                  {item.name}
                </a>)}
              <Button href="/book-call" className="w-full" showArrow data-id="element-74">
                Schedule a Strategy Call
              </Button>
            </div>
          </div>}
      </nav>
    </header>;
}